import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Routes } from '../../routes';

@Component({
  selector: 'app-finish-account',
  templateUrl: './finish-account.component.html',
  styleUrls: [
    '../account-migration-login/account-migration-login.component.scss',
    './finish-account.component.scss',
  ],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Finish Account Component!
 */
export class FinishAccountComponent {
  /**
   * @constructor
   */
  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute
  ) {}
  /**
   * finishes creating account
   */
  finishCreatingAccount() {
    this.router.navigate([`../${Routes.CONFIRM_DATA}`], {
      relativeTo: this.activatedRoute,
    });
  }
}
